<h2 class="!font-poppins !text-md !text-primary-900 !font-semibold p-6 pb-2">
  @switch (data.type) {
  @case ('pax') {
  <p>Pasajero</p>
  }
  @case ('class') {
  <p>Clase</p>
  }
  @case ('money') {
  <p>Moneda</p>
  }
  }
</h2>
<mat-dialog-content class="mat-typography">
  @switch (data.type) {
  @case ('pax') {
  <div class="flex flex-col gap-4">
    @for (type of paxTypes; track type.key) {
    <div class="flex gap-4 justify-between items-center">
      <div>
        <p class="text-primary-800 text-sm font-medium !font-poppins">
          {{ type.label }}
          <br />
          <small class="text-primary-400 text-2xs font-medium !font-poppins">
            {{ type.description }}
          </small>
        </p>
      </div>
      <div class="rounded-lg border border-neutral-200 flex items-center justify-center">
        <button type="button" mat-icon-button class="p-2.5 leading-none h-10"
          (click)="handlerPax('decrement', type.key)">
          <img [src]="pax[type.key] <= type.min ? minusDisabled : minus" alt="icon" class="w-5 h-5" />
        </button>
        <div class="p-2.5 h-10 w-[58px] bg-neutral-100 text-center border-x border-neutral-200">
          <p class="text-xs text-primary-800 font-medium !font-poppins">
            {{ pax[type.key] }}
          </p>
        </div>
        <button type="button" mat-icon-button class="p-2.5 leading-none h-10" [disabled]="totalPax >= 9"
          (click)="handlerPax('increment', type.key)">
          <img [src]=" totalPax < 9 ? add : addDisabled" alt="icon" class="w-5 h-5" />
        </button>
      </div>
    </div>
    }
  </div>
  }
  @case ('class') {
  @for (option of optionClass; track $index; let i = $index) {
  <div class="flex items-center gap-2 my-2">
    <div class="w-5 h-5 cursor-pointer rounded-full border-2 flex items-center justify-center" [ngClass]="{
              'border-secondary-600': selectClass.value === option.value,
              'border-primary-800': selectClass.value !== option.value,
            }" (click)="onSelectClass(option)">
      <div class="w-2.5 h-2.5 rounded-full" [ngClass]="{
                'bg-secondary-600': selectClass.value === option.value,
                'bg-transparent': selectClass.value !== option.value,
              }"></div>
    </div>
    <p class="text-xs text-primary-800 font-medium !font-poppins">
      {{ option.label }}
    </p>
  </div>
  }
  }
  @case ('money') {
  @for (option of optionMoney; track $index; let i = $index) {
  <div class="flex items-center gap-2 my-2">
    <div class="w-5 h-5 cursor-pointer rounded-full border-2 flex items-center justify-center" [ngClass]="{
              'border-secondary-600': selectMoney.value === option.value,
              'border-primary-800': selectMoney.value !== option.value,
            }" (click)="onSelectMoney(option)">
      <div class="w-2.5 h-2.5 rounded-full" [ngClass]="{
                'bg-secondary-600': selectMoney.value === option.value,
                'bg-transparent': selectMoney.value !== option.value,
              }"></div>
    </div>
    <p class="text-xs text-primary-800 font-medium !font-poppins">
      {{ option.label }}
    </p>
  </div>
  }
  }
  }
</mat-dialog-content>
<mat-dialog-actions class="!p-4 flex flex-col gap-6">
  <app-button size="Modal" text="Aplicar" color="Secondary" (buttonClick)="selectOption()" [width]="265" />
  <app-button mat-dialog-close size="Modal" text="Cancelar" color="Primary" [width]="265" />
</mat-dialog-actions>